module.exports = __webpack_public_path__ + "img/company-honor-TPD-20231219.33acae82.jpg";